export default __webpack_public_path__ + "static/media/fMaltoBuza33.3f300570.png";